/**
 * Single source of truth for company details.
 *
 * These strings previously appeared inline in the landing page, both layouts,
 * and both footers — which is how the app ended up calling itself
 * "Pro Shipping Solutions", "Pro Shipping", and "Pro Shipping Manager" in
 * three different places. Change them here and everywhere follows.
 *
 * TODO(business): replace the two placeholder values marked below with the
 * real details before launch. `phone` is currently the fictional 555 number
 * that shipped in the original landing page.
 */
export const COMPANY = {
  name: 'Pro Shipping Solutions',
  shortName: 'Pro Shipping',
  email: 'proshippingsolutions@gmail.com',
  phone: '(242) 555-1234', // TODO(business): real number
  phoneHref: 'tel:+12425551234',
  hours: 'Mon – Fri · 8:00 AM – 5:00 PM EST',
  addressLines: [
    'Nassau, New Providence', // TODO(business): real street address
    'The Bahamas',
  ],
} as const

/**
 * Where shipments are received before they move. Customers don't enter this —
 * it's the same for every shipment, so the New Shipment form fills it in and
 * the customer only confirms where the package is *going*.
 */
export const WAREHOUSE_ORIGIN = {
  street: '2000 NW 89th Pl',
  city: 'Miami',
  state: 'FL',
  zipCode: '33172',
  country: 'USA',
} as const

/** Islands / major settlements, used for the delivery-address picker. */
export const BAHAMAS_ISLANDS = [
  'New Providence (Nassau)',
  'Grand Bahama (Freeport)',
  'Abaco',
  'Eleuthera',
  'Exuma',
  'Andros',
  'Bimini',
  'Cat Island',
  'Long Island',
  'Inagua',
  'Berry Islands',
  'Acklins',
  'Crooked Island',
  'Mayaguana',
  'Ragged Island',
  'San Salvador',
  'Rum Cay',
] as const
